<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Consultando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="contrato"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-file-arrow-up-down-outline"
            title="Gestão de Arquivos"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-container>
              <v-row class="px-4 py-4">
                <v-col cols="6" md="6">
                  <span>Consultar arquivo</span>
                  <v-text-field
                    v-model.trim="search"
                    label="Consultar arquivo"
                    solo-inverted
                    dense
                    hide-details
                    placeholder="Digite uma palavra para consultar o arquivo..."
                    @keyup.enter="isSearchEnabled && searchFiles(currentPage)"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="6" md="6">
                  <span>Empresa</span>
                  <v-select
                    v-model="selectedCompany"
                    :items="filteredEmpresas"
                    @input="handleEmpresaSelection"
                    label="Selecione a empresa"
                    multiple
                    deletable-chips
                    solo-inverted
                    dense
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" md="6" class="pb-0">
                  <span>Departamento</span>
                  <v-select
                    v-model="selectedDepartamentos"
                    :items="departamentos"
                    label="Selecione um departamento"
                    solo-inverted
                    dense
                    clearable
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" md="6" class="pb-0">
                  <span>Categoria</span>
                  <v-select
                    v-model="selectedCategoria"
                    :items="categoriasDisponiveis"
                    label="Selecione uma categoria"
                    solo-inverted
                    dense
                    clearable
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" md="6" v-if="selectedCategoria">
                  <span>Subcategoria</span>
                  <v-select
                    v-model="selectedSubCategoria"
                    :items="subcategoriasDisponiveis"
                    label="Selecione uma subcategoria"
                    solo-inverted
                    dense
                    clearable
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" class="pt-2 d-flex justify-start align-center">
                  <v-checkbox
                    v-model="showDatas"
                    label="Filtrar data de inclusão"
                    hide-details
                    class="mt-0 mr-12"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="logado"
                    label="Criados ou atualizados por mim"
                    hide-details
                    class="mt-0 ml-12"
                  ></v-checkbox>
                </v-col>
                <v-col cols="2" sm="6" md="3" v-if="showDatas">
                  <span>Data Inicial</span>
                  <v-menu
                    v-model="isStartDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedStartDate"
                        label="Data Inicial"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedStartDateISO"
                      @input="handleStartDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="2" sm="6" md="3" v-if="showDatas">
                  <span>Data Final</span>
                  <v-menu
                    v-model="isEndDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="selectedEndDate"
                        label="Data Final"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedEndDateISO"
                      @input="handleEndDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <div class="d-flex justify-end mr-8">
                <v-btn
                  color="success"
                  @click="novoDocumento"
                  dense
                  width="140"
                  height="32"
                  class="text-capitalize font-weight-bold mr-4"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Novo Arquivo
                </v-btn>

                <v-btn
                  color="primary"
                  @click="limparFiltros"
                  dense
                  width="140"
                  height="32"
                  outlined
                  class="text-capitalize font-weight-bold mr-4"
                >
                  <v-icon left>mdi-broom</v-icon>
                  Limpar Filtros
                </v-btn>
                <v-btn
                  color="primary"
                  @click="searchFiles(currentPage)"
                  :loading="loading"
                  :disabled="!selectedCompany.length"
                  elevation="2"
                  dense
                  width="140"
                  height="32"
                  class="text-capitalize font-weight-bold mr-4"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </div>

              <v-data-table
                :headers="headers"
                :items="files"
                :loading="loading"
                :items-per-page="50"
                hide-default-footer
                :items-per-page-text="'Registros por página'"
                class="elevation-0 text-center mt-10"
                style="margin-top: 1rem; min-height: 30vh"
                no-data-text="Nenhum arquivo encontrado"
              >
                <template v-slot:item="row">
                  <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                    <td
                      class="linha"
                      style="
                        font-size: 12px !important;
                        font-weight: bold !important;
                        text-align: center;
                        font-family: Verdana, Geneva, Tahoma, sans-serif;
                      "
                    >
                      {{ truncateText(row.item.nomeArquivo, 30) || "-" }}
                    </td>
                    <td class="linha">
                      {{ row.item.identificacao || "-" }}
                    </td>
                    <td class="linha">{{ row.item.descricao || "-" }}</td>
                    <td class="linha">{{ row.item.categoria || "-" }}</td>
                    <td class="linha">{{ row.item.subCategoria || "-" }}</td>
                    <td class="linha">
                      {{ formatarData(row.item.dataInsert) || "-" }}
                    </td>
                    <td class="linha">{{ row.item.empresa || "-" }}</td>

                    <td class="linha">
                      <v-chip
                        :color="
                          row.item.status === 'Ativo' ? 'success' : 'error'
                        "
                      >
                        {{ row.item.status || "-" }}
                      </v-chip>
                    </td>
                    <td class="linha">
                      <v-icon
                        size="22"
                        class="mr-2"
                        @click="consultarAquivoDetalhado(row.item)"
                        title="Visualizar arquivo"
                      >
                        mdi-eye
                      </v-icon>
                      <v-icon
                        size="22"
                        class="mr-2"
                        @click="downloadFile(row.item)"
                        title="Baixar arquivo"
                      >
                        mdi-download
                      </v-icon>
                      <v-icon
                        size="22"
                        class="mr-2"
                        title="Alterar status do arquivo"
                        @click="alterarStatusArquivo(row.item)"
                      >
                        {{
                          row.item.status === "Ativo"
                            ? "mdi-close"
                            : "mdi-check"
                        }}
                      </v-icon>
                    </td>
                  </tr>
                </template>

                <template v-slot:footer="{}">
                  <v-spacer></v-spacer> <br />
                  <v-row class="d-flex justify-center">
                    <v-col cols="12" sm="6">
                      <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        @input="changePage"
                        :max="3"
                        :total-visible="7"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-container>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog de Preview -->
    <!-- <v-dialog
      v-model="previewDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="preview-dialog">
        <v-toolbar dark color="primary" class="preview-toolbar">
          <v-toolbar-title>Visualização do Arquivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="previewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="preview-content pa-0">
          <iframe
            v-if="previewUrl"
            :src="`data:application/pdf;base64,${previewUrl}`"
            type="application/pdf"
            class="preview-iframe"
            frameborder="0"
            @load="handleIframeLoad"
            @error="handleIframeError"
          ></iframe>
          <div v-else-if="previewError" class="preview-error">
            <v-alert type="error" dense>
              Erro ao carregar o preview do arquivo. Por favor, tente novamente.
            </v-alert>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </v-app>
</template>

<script>
import { http } from "../../services/config";
import authHeader from "../../services/auth-header";
import gedService from "../../services/ged";
import axios from "axios";

console.log(http);
console.log(authHeader());

export default {
  name: "GestaoArquivos",
  data: () => ({
    currentPage: 1, // Página atual
    itemsPerPage: 10, // Itens por página
    totalPages: 0,
    categorias: [
      "Contratos",
      "Relatórios",
      "Procedimentos",
      "Processos",
      "Políticas",
      "Financeiro",
      "Recursos Humanos",
      "Jurídico",
      "Técnico",
    ],
    categoriasMarketing: [
      "Instagram",
      "Facebook",
      "TikTok",
      "YouTube",
      "LinkedIn",
      "X (Twitter)",
      "Pinterest",
      "Google",
      "Meta Ads",
    ],
    categoriasMap: {
      Contratos: [
        "Planos",
        "Jazigos",
        "Cancelamentos",
        "Clientes",
        "Fornecedores",
        "Locação",
        "Manutenção",
        "Parceiros",
        "Prestação de Serviços",
      ],
      Relatórios: [
        "Relatório Anual",
        "Relatório de Auditoria",
        "Relatório de Desempenho",
        "Relatório de Vendas",
        "Relatório Financeiro",
        "Relatório Mensal",
      ],
      Procedimentos: [
        "Instruções de Trabalho",
        "Manual de Operação",
        "Procedimento Administrativo",
        "Procedimento de Qualidade",
        "Procedimento Operacional",
        "Procedimento de Segurança",
      ],
      Políticas: [
        "Código de Conduta",
        "Normas Internas",
        "Política de Compliance",
        "Política de Privacidade",
        "Política de RH",
        "Política de Segurança",
      ],
      Financeiro: [
        "Caixa",
        "Comprovantes",
        "Demonstrativos",
        "Extratos",
        "Impostos",
        "Notas Fiscais",
        "Orçamentos",
      ],
      "Recursos Humanos": [
        "Avaliações",
        "Benefícios",
        "Documentos Pessoais",
        "Férias",
        "Folha de Pagamento",
        "Treinamentos",
      ],
      Jurídico: [
        "Certidões",
        "Documentos Societários",
        "Licenças",
        "Pareceres",
        "Processos",
        "Procurações",
      ],
      Técnico: [
        "Certificações",
        "Especificações",
        "Laudos Técnicos",
        "Manuais Técnicos",
        "Plantas",
        "Projetos",
      ],
      Processos: ["Sorteio", "Regulação", "Apólice"],
      Instagram: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      Facebook: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      TikTok: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      YouTube: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      LinkedIn: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      "X (Twitter)": [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      Pinterest: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      Google: [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
      "Meta Ads": [
        "Anúncio Single Image",
        "Banner do Canal",
        "Capa (Header)",
        "Capa de Evento",
        "Capa de Página",
        "Capa de Perfil",
        "Carrossel",
        "Feed (Quadrado)",
        "Feed (Retrato)",
        "Feed Post (Paisagem)",
        "Feed Post (Quadrado)",
        "Foto de Perfil",
        "Half Page",
        "Idea Pin",
        "Imagem Paisagem",
        "In-Feed Video",
        "Large Rectangle",
        "Leaderboard",
        "Logo de Empresa",
        "Medium Rectangle",
        "Mobile Leaderboard",
        "Post de Imagem",
        "Reels",
        "Responsive Display (Landscape)",
        "Responsive Display (Square)",
        "Shorts",
        "Standard Pin",
        "Stories",
        "Stories/Reels Ads",
        "Story",
        "Thumbnail de Vídeo",
        "Wide Skyscraper",
      ],
    },
    departamentos: [
      "Administrativo",
      "Comercial",
      "Call Center",
      "Financeiro",
      "Faturamento e Contratos",
      "RH",
      "Operacional",
      "Jurídico",
      "TIC",
      "Compras",
      "Marketing",
      "Diretoria",
      "Seguros",
      "SAC",
    ],
    loading: false,
    search: "",
    selectedCompany: [],
    selectedCategoria: "",
    selectedSubCategoria: "",
    selectedDepartamentos: "",
    logado: false,
    previewDialog: false,
    previewUrl: "",
    previewError: false,
    searchParams: {
      termo: "",
      empresas: "",
      categoria: "",
      subcategoria: "",
      departamentos: "",
      logado: false,
    },

    headers: [
      // { text: "#", value: "id", align: "center", width: "50px" },
      { text: "Arquivo", value: "nomeArquivo", align: "center" },
      { text: "Nº identificação", value: "identificacao", align: "center" },
      { text: "Descrição", value: "descricao", align: "center" },
      { text: "Categoria", value: "categoria", align: "center" },
      { text: "Subcategoria", value: "subCategoria", align: "center" },
      { text: "Data de Inclusão", value: "dataInsert", align: "center" },
      { text: "Empresa", value: "empresa", align: "center" },
      { text: "Status", value: "status", align: "center" },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
        align: "center",
        width: "150px",
      },
    ],
    files: [],
    showProgress: false,
    empresas: [
      "CEMITERIO PREVIDA",
      "MEMORIAL PARQUE MACEIÓ",
      "PARQUE DAS FLORES",
      "PARQUE DO AGRESTE",
      "PREVIDA",
      "A FLOR DO CAFÉ",
      "CEMITERIO PREVIDA SÃO MIGUEL",
    ],
    user: {},
    showDatas: false,
    selectedStartDate: "",
    selectedEndDate: "",
    localSelectedStartDateISO: "",
    localSelectedEndDateISO: "",
    isStartDatePickerOpen: false,
    isEndDatePickerOpen: false,
  }),
  computed: {
    categoriasDisponiveis() {
      if (this.selectedDepartamentos === "Marketing") {
        return this.categoriasMarketing;
      }
      return this.categorias;
    },
    subcategoriasDisponiveis() {
      return this.selectedCategoria
        ? this.categoriasMap[this.selectedCategoria] || []
        : [];
    },
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    isSearchEnabled() {
      return this.search.trim() !== "" && this.selectedCompany.length > 0;
    },
  },
  watch: {
    selectedDepartamentos(newDepartamento) {
      // Limpa a categoria e subcategoria quando o departamento muda
      this.selectedCategoria = "";
      this.selectedSubCategoria = "";
    },
  },
  mounted() {
    const dadosFiltradosSalvos = sessionStorage.getItem("consulta");
    if (dadosFiltradosSalvos) {
      this.files = JSON.parse(dadosFiltradosSalvos);
    }

    const filtrosSalvos = sessionStorage.getItem("filtros");
    if (filtrosSalvos) {
      const filtros = JSON.parse(filtrosSalvos);
      this.search = filtros.termo || "";
      this.selectedCompany = filtros.empresas
        ? filtros.empresas.split(",")
        : [];
      this.selectedCategoria = filtros.categoria || "";
      this.selectedSubCategoria = filtros.subcategoria || "";
      this.selectedDepartamentos = filtros.departamentos || "";
      this.logado = filtros.logado || false;
      this.localSelectedStartDateISO = filtros.dataInicial || "";
      this.localSelectedEndDateISO = filtros.dataFinal || "";
    }
    this.iniciarDatas();

    this.$nextTick(() => {
      this.autoSelectEmpresa();
    });
  },
  methods: {
    autoSelectEmpresa() {
      const empresasPermitidas = this.empresas.filter((empresa) =>
        this.hasPermission(empresa),
      );

      if (empresasPermitidas.length === 1) {
        this.selectedCompany = empresasPermitidas[0];
      }
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    formatarData(data) {
      if (!data) return "";
      const [year, month, day] = data.split("-");
      return `${day}/${month}/${year}`;
    },
    iniciarDatas() {
      this.selectedStartDate = this.convertToBR(
        new Date().toISOString().split("T")[0],
      );
      this.selectedEndDate = this.convertToBR(
        new Date().toISOString().split("T")[0],
      );
      this.localSelectedStartDateISO = new Date().toISOString().split("T")[0];
      this.localSelectedEndDateISO = new Date().toISOString().split("T")[0];
    },
    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.localSelectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },
    changePage() {
      this.loading = true;
      this.searchFiles(this.currentPage);
    },
    consultarAquivoDetalhado(item) {
      const filtrosSalvos = {
        termo: this.search,
        empresas: Array.isArray(this.selectedCompany)
          ? this.selectedCompany.join(",")
          : this.selectedCompany || "Todas",
        categoria: this.selectedCategoria || "",
        subcategoria: this.selectedSubCategoria || "",
        departamentos: this.selectedDepartamentos || "",
        logado: this.logado,
        dataInicial: this.localSelectedStartDateISO,
        dataFinal: this.localSelectedEndDateISO,
      };

      sessionStorage.setItem("filtros", JSON.stringify(filtrosSalvos));
      sessionStorage.setItem("consulta", JSON.stringify(this.files));
      this.$router.push(`/consultaArquivo/${item.id}`);
    },
    async downloadFile(item) {
      const id = item.arquivoExterno;
      this.showProgress = true;

      try {
        // TORNA PÚBLICO
        await http.patch(`/ged/arquivos/${id}/permissao`, null, {
          params: { permissao: "publico" },
          headers: authHeader(),
        });

        // MONTA URL OFICIAL
        const downloadUrl = `https://drive.google.com/uc?export=download&id=${id}`;

        // ABRE DOWNLOAD
        window.open(downloadUrl, "_blank");

        // ESPERA O DRIVE PROCESSAR (IMPORTANTE)
        setTimeout(async () => {
          try {
            await http.patch(`/ged/arquivos/${id}/permissao`, null, {
              params: { permissao: "privado" },
              headers: authHeader(),
            });
          } catch (e) {
            console.error("Erro ao voltar arquivo para privado", e);
          }
        }, 30000); // 30 segundos
      } catch (error) {
        console.error("Erro no fluxo de download:", error);
        this.showSnackbar(
          "Erro ao preparar download do arquivo.",
          "error",
          3000,
        );
      } finally {
        this.showProgress = false;
      }

      // this.showProgress = true;
      // try {
      //   let tipo = item.tipo;
      //   let nome = item.nome || "arquivo";

      //   const response = await http.get("/ged/download", {
      //     params: {
      //       arquivoExterno: item.arquivoExterno,
      //     },
      //     headers: authHeader(),
      //   });

      //   item.base64 = response.data.base64;
      //   item.arquivoExterno = response.data.id;

      //   tipo = response.data.tipoArquivo;
      //   nome = response.data.nome || "arquivo";

      //   // Converte base64 para blob
      //   const byteCharacters = atob(item.base64);
      //   const byteNumbers = new Array(byteCharacters.length);
      //   for (let i = 0; i < byteCharacters.length; i++) {
      //     byteNumbers[i] = byteCharacters.charCodeAt(i);
      //   }

      //   const byteArray = new Uint8Array(byteNumbers);
      //   const blob = new Blob([byteArray], { type: tipo });

      //   // Cria URL do blob
      //   const url = window.URL.createObjectURL(blob);

      //   // Deriva extensão do tipo MIME se necessário
      //   const getExtensaoPorMimeType = (mimeType) => {
      //     const mapa = {
      //       "application/pdf": "pdf",
      //       "image/jpeg": "jpg",
      //       "image/png": "png",
      //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      //         "docx",
      //       "application/msword": "doc",
      //       "application/vnd.ms-excel": "xls",
      //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      //         "xlsx",
      //       "application/planilha": "xls",
      //       "text/plain": "txt",
      //       "application/zip": "zip",
      //     };
      //     return mapa[mimeType] || "bin";
      //   };

      //   // Garante nome com extensão
      //   const extensao = getExtensaoPorMimeType(tipo);
      //   const nomeFinal = `${item.titulo}.${extensao}`;

      //   // Cria link temporário e dispara download
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = nomeFinal;
      //   document.body.appendChild(link);
      //   link.click();

      //   // Limpa
      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);
      // } catch (error) {
      //   console.error("Erro ao baixar arquivo:", error);
      // } finally {
      //   this.showProgress = false;
      // }
    },
    alterarStatusArquivo(item) {
      const novoStatus = item.status === "Ativo" ? "Cancelado" : "Ativo";
      gedService
        .alterarStatusArquivo(item.id, novoStatus)
        .then(() => {
          // Atualiza o status na interface imediatamente
          item.status = novoStatus;
          this.$forceUpdate();
          // Recarrega os dados
          this.searchFiles(this.currentPage);
        })
        .catch((error) => {
          console.error("Erro ao alterar status do arquivo:", error);
        });
    },
    removeEmpresa(empresa) {
      const index = this.selectedCompany.indexOf(empresa);
      if (index >= 0) {
        this.selectedCompany.splice(index, 1);
      }
    },

    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"),
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role),
        );
        return hasAnyRequiredRole;
      }
    },
    async searchFiles(pageNumber) {
      sessionStorage.removeItem("consulta");
      sessionStorage.removeItem("filtros");

      // Atualiza os parâmetros de busca
      this.searchParams = {
        termo: this.search,
        empresas: Array.isArray(this.selectedCompany)
          ? this.selectedCompany.join(",")
          : this.selectedCompany || "Todas",
        categoria: this.selectedCategoria || "",
        subcategoria: this.selectedSubCategoria || "",
        departamentos: this.selectedDepartamentos || "",
        logado: this.logado,
        dataInicial: this.showDatas
          ? this.localSelectedStartDateISO
          : "1900-01-01",
        dataFinal: this.showDatas ? this.localSelectedEndDateISO : "1900-01-01",
      };

      this.loading = true;
      try {
        const response = await http.get("/ged/busca", {
          params: {
            buscaArquivo: this.searchParams.termo,
            empresas: this.searchParams.empresas,
            categoria: this.searchParams.categoria,
            subcategoria: this.searchParams.subcategoria,
            departamentos: this.searchParams.departamentos,
            logado: this.searchParams.logado,
            page: pageNumber,
            size: this.itemsPerPage,
            dataInicial: this.searchParams.dataInicial,
            dataFinal: this.searchParams.dataFinal,
          },
          headers: authHeader(),
        });

        if (response.data) {
          this.files = response.data.content;
          this.totalPages = response.data.totalPages;
        }
      } catch (error) {
        console.error("Erro ao buscar arquivos:", error);
        this.files = [];
      } finally {
        this.loading = false;
      }
    },
    handleEmpresaSelection() {
      if (this.selectedCompany.includes("Todas")) {
        // Se "Todas" estiver selecionada, desabilita as outras opções
        this.selectedCompany = ["Todas"];
      }
    },

    formatarCampoData(valor) {
      if (!valor) return "-";

      // Verifica se é uma data válida
      const data = new Date(valor);
      if (isNaN(data.getTime())) {
        // Tenta outros formatos comuns de data
        const formatos = [
          /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
          /^\d{2}\/\d{2}\/\d{4}$/, // DD/MM/YYYY
          /^\d{2}-\d{2}-\d{4}$/, // DD-MM-YYYY
        ];

        for (const formato of formatos) {
          if (formato.test(valor)) {
            // Converte para o formato brasileiro
            const [ano, mes, dia] = valor.split(/[-\/]/).reverse();
            return `${dia}/${mes}/${ano}`;
          }
        }
        return valor; // Retorna o valor original se não for data
      }

      // Se for uma data válida, formata para o padrão brasileiro
      return data.toLocaleDateString("pt-BR");
    },
    novoDocumento() {
      this.$router.push({ name: "Novos Arquivos" });
    },
    handleIframeLoad() {
      console.log("Preview carregado com sucesso");
      this.previewError = false;
    },

    handleIframeError() {
      console.error("Erro ao carregar preview no iframe");
      this.previewError = true;
    },
    limparFiltros() {
      // Remove filtros e resultados do sessionStorage
      sessionStorage.removeItem("filtros");
      sessionStorage.removeItem("consulta");
      // Limpa os campos de filtro
      this.search = "";
      this.selectedCompany = [];
      this.selectedCategoria = "";
      this.selectedSubCategoria = "";
      this.selectedDepartamentos = "";
      this.logado = false;
      this.files = [];
      this.currentPage = 1;
      this.totalPages = 0;
      this.iniciarDatas();
    },
  },
};
</script>

<style scoped>
.preview-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.preview-toolbar {
  flex: 0 0 auto;
}

.preview-content {
  flex: 1 1 auto;
  position: relative;
  height: calc(100vh - 64px);
}

.preview-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.custom-input ::v-deep .v-input__slot {
  background-color: white !important;
}

.linha {
  font-size: 12px !important;
  font-weight: bold !important;
  text-align: center;
}

.cor-row {
  background-color: #90d34c21;
  transition: none !important;
}

.v-data-table {
  background-color: white !important;
}

.info-cell {
  padding: 12px 16px !important;
}

.info-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  min-width: 70px;
}

.info-value {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 600 !important;
}

.v-chip {
  font-size: 12px !important;
}

.v-select.v-text-field--outlined:not(.v-text-field--single-line)
  ::v-deep
  .v-select__selection--comma {
  margin-top: 0;
  font-size: 14px;
}

.v-text-field--outlined ::v-deep fieldset {
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.v-text-field--outlined:hover ::v-deep fieldset {
  border-color: rgba(0, 0, 0, 0.24) !important;
}
</style>
